module.exports = __webpack_public_path__ + "img/cycle.b76a4ea2.png";